module.exports = __webpack_public_path__ + "img/events-live.5bf95162.png";